import type { FC } from 'react'
import type { DragSourceMonitor } from 'react-dnd'
import { useDrag } from 'react-dnd'
import { OwnershipInformationdata } from '../ownershipForm/OwnershipInformationdata'


export interface BoxProps {
  item: OwnershipInformationdata
}

export const DragItem: FC<BoxProps> = ({ item }) => {
  const [{ opacity }, drag] = useDrag(
    () => ({
      type: "card",
      item: item ,
      collect: (monitor: DragSourceMonitor) => ({
        opacity: monitor.isDragging() ? 0.1 : 1,
      }),
    }),
    [item],
  )
  return (
    <div ref={!item?.grouped ? drag : undefined} style={{opacity}}
      className={`dragItem ${item?.grouped ? "grouped" : ""}`}>
      {item?.firstname + " "+item.lastname}
    </div>
  )
}

